// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Tgwl","inner":"Footer_inner__2bFe9"};